import { render } from "./create-employee.vue?vue&type=template&id=402de409&scoped=true"
import script from "./create-employee.vue?vue&type=script&lang=js"
export * from "./create-employee.vue?vue&type=script&lang=js"

import "./create-employee.vue?vue&type=style&index=0&id=402de409&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402de409"]])

export default __exports__